// src/hooks/useRoxFlag.js
import { useEffect, useState } from 'react';
import { getFlagsSnapshot, subscribeFlags } from '../flags';

/**
 * React hook returning the current boolean value of a flag key from flags.js.
 * Example: const isOn = useRoxFlag('showTelemetry');
 */
export default function useRoxFlag(key) {
  const [val, setVal] = useState(() => !!getFlagsSnapshot()[key]);

  useEffect(() => {
    const unsubscribe = subscribeFlags((_reason, snap) => {
      setVal(!!snap[key]);
    });
    return unsubscribe;
  }, [key]);

  return val;
}
